var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"csn-notification-list"},[_c('div',{staticClass:"cs-textstyle-tags csn-notification-list__title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_vm._l((_vm.notifications),function(notification){return _c('notification-item',{key:notification.id,attrs:{"notification":notification}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }